import {createAction, props} from '@ngrx/store';

export const SendAction = createAction(
    '[Action] - Send external action',
    props<{ actionId: string }>()
);
export const SendActionSuccess = createAction(
    '[Action] - Send external action - Success',
    props<{ actionId: string }>()
);
export const SendActionFailure = createAction(
    '[Action] - Send external action - Failure',
    props<{ message: string }>()
);
